export default __webpack_public_path__ + "media/favicon.078aa083.ico";